import { useRecord } from "./useRecord";

export function useMessage(messageId?: string | null) {
  return useRecord("message", messageId);
}
